import "./index.scss";
import { CfImageProps } from "components/Image/types";
import { LiveInspectorData } from "types/types";
import HeroImage from "components/HeroImage";
import PostShareAndInfo from "../PostShareAndInfo";
import React from "react";

interface Props {
  date?: string;
  location?: string;
  image: CfImageProps[];
  title?: string;
  liveInspector?: LiveInspectorData;
}

export default function PostHeader({
  date,
  location,
  image,
  title,
  liveInspector,
}: Props) {
  const imagePost = image?.[0]?.imageDesktop?.file?.url;
  return (
    <div
      className="PostHeader container-fluid mb--lg"
      {...liveInspector?.postHeader}
    >
      <div className="row justify-content-center">
        <div className="col-12 col-md-8">
          <h1 className="PostHeader__title pt--xl pb--xs">{title}</h1>
          <PostShareAndInfo date={date} location={location} />
          <div className="mb--lg">
            <HeroImage image={imagePost} />
          </div>
        </div>
      </div>
    </div>
  );
}
